import { FlowRequest } from "@/types/app/flow";

export const DEFAULT_FLOW: Omit<FlowRequest, "commit_message" | "version_name" | "version_description"> = {
  attributes: {},
};
